import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";
import { URL } from "modules/utils/Common";
const NoticeContext = React.createContext({
  state: { noticeList: {}, notice: {} },
  actions: {
    getNotice: () => { },
    getNoticeList: () => { },
  },
});

const NoticeProvider = ({ children }) => {
  const [notice, setNotice] = useState({});
  const [noticeList, setNoticeList] = useState([]);

  const getNoticeList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/notice/list",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        noticeTitle: pageInfo && pageInfo.noticeTitle,
      },
    }).then((res) => {
      if (res.code === 200) {
        setNoticeList(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getNotice = useCallback((noticeId) => {
    HttpAction({
      url: "api/admin/notice",
      method: "get",
      params: {
        noticeId: noticeId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setNotice(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createNotice = useCallback(async (noticeData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
    await axios
      .post(`api/admin/notice/save`, noticeData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getNoticeList({})
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const updateNotice = useCallback(async (noticeData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
    await axios
      .post(`api/admin/notice/modify`, noticeData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const deleteNotice = useCallback((noticeId, history) => {
    HttpAction({
      url: "api/admin/notice",
      method: "delete",
      params: {
        noticeId: noticeId,
      },
    }).then((res) => {
      if (res.code === 200) {
        history.push(`${URL.ADMIN_BASE_URL}/promotion/notice`);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { notice, noticeList },
    actions: {
      getNoticeList,
      getNotice,
      createNotice,
      updateNotice,
      deleteNotice,
    },
  };

  return (
    <NoticeContext.Provider value={value}>{children}</NoticeContext.Provider>
  );
};

const { Consumer: NoticeConsumer } = NoticeContext;

export { NoticeProvider, NoticeConsumer, NoticeContext };

export default NoticeContext;
